"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var get_1 = __importDefault(require("lodash/get"));

exports.getFirstApolloError = function (error) {
  var err = get_1.default(error, "graphQLErrors[0]") || get_1.default(error, "networkError.result.errors[0]");

  if (err) {
    var code = get_1.default(err, "extensions.code");
    return {
      code: code,
      message: err.message
    };
  } else {
    return undefined;
  }
};

exports.getMessageFromApolloError = function (error) {
  var err = exports.getFirstApolloError(error);
  return err ? err.message : error.message;
};

__export(require("./errorCodes"));